module.exports = __webpack_public_path__ + "static/media/15UN-Habitat1.a71921aa.jpg";